import { HiCheckCircle } from 'react-icons/hi';


const Item = ({ pop, title, price, features }) =>{
  return(
    <div className={pop? "bg-primary w-100 box shadow-lg text-white" : 'w-100 box shadow-lg text-primary'}>
      <h5>
        {title}
      </h5>
      <h1 className="d-flex align-items-center font-weight-bold">
        ${price}
        <small
        style={{fontSize: '18px'}}>
          / month
        </small>
      </h1>
      <p
      style={{fontSize: '16px'}}
      className="font-weight-bold mt-4">
        for most Businesses that want to optimize web queries
      </p>
      {
        features.map((e) =>(
          <h5 style={{fontSize: '18px', fontWeight: 600}}>
            <HiCheckCircle size={24} /> {e}
          </h5>
        ))
      }
      <div className="row justify-content-center mt-5">
        <button className={pop? "btn btn-outline-light btn-lg mt-5" : "btn btn-outline-primary btn-lg mt-5"}>
          choose plan
        </button>
      </div>
    </div>
  );
};
export default Item;